module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sert"
  }, [_vm._v("And again…")]), _vm._v(" "), _c('p', {
    staticClass: "ser2"
  }, [_vm._v("To")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("George MacDonald")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("and")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("C.S. Lewis…")]), _vm._v(" "), _c('p', {
    staticClass: "ser2"
  }, [_vm._v("worthy mentors with broad shoulders")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("who paved the way.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-599be09e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hell_and_Beyond_Split3.vue
// module id = 63
// module chunks = 0